import { Component, OnInit } from '@angular/core';
import { ImageViewerConfig, CustomImageEvent } from 'angular-x-image-viewer';
@Component({
  selector: 'mrsoftapps-documentoperations',
  templateUrl: './documentoperations.component.html',
  styleUrls: ['./documentoperations.component.css']
})
export class DocumentoperationsComponent implements OnInit {
  OriginatingModule: string = "General";
  OriginatedModuleSpecificId: string = "Gen"
  constructor() { }

  ngOnInit() {
  }

}
